module.exports = __webpack_public_path__ + "img/avi.aa28f9ea.jpg";